function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M87.2164 0.5H0V96.5H87.2164V0.5Z",
  fill: "#3600FA"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3871 17.7031H30.7754L38.6065 28.2902V17.7031H42.2346V34.8975H39.1091L31.0152 23.9686V34.8975H27.3871V17.7031Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5397 48.5498V48.4993C17.5397 43.613 21.1187 39.6094 26.2518 39.6094C29.4033 39.6094 31.2867 40.6913 32.8407 42.2606L30.5009 45.0367C29.2126 43.8329 27.8983 43.0958 26.2287 43.0958C23.4123 43.0958 21.3844 45.5033 21.3844 48.4488V48.4963C21.3844 51.4448 23.366 53.8998 26.2287 53.8998C28.138 53.8998 29.3079 53.1152 30.6223 51.8847L32.9621 54.316C31.2433 56.2063 29.3339 57.3863 26.1102 57.3863C21.1909 57.3922 17.5397 53.4867 17.5397 48.5498Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7218 48.5498V48.4993C33.7218 43.613 37.4684 39.6094 42.6246 39.6094C47.7808 39.6094 51.4811 43.5624 51.4811 48.4518V48.4993C51.4811 53.3886 47.7345 57.3922 42.5783 57.3922C37.4221 57.3922 33.7218 53.4392 33.7218 48.5498ZM47.6392 48.5498V48.4993C47.6392 45.5538 45.5392 43.0958 42.5783 43.0958C39.6175 43.0958 37.5666 45.5033 37.5666 48.4488V48.4963C37.5666 51.4448 39.6666 53.8998 42.6274 53.8998C45.5854 53.9058 47.6392 51.4983 47.6392 48.5498Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M53.7978 39.9062H61.4353C63.5585 39.9062 65.2079 40.5215 66.3056 41.6509C67.2357 42.608 67.7383 43.9604 67.7383 45.5802V45.6278C67.7383 48.4039 66.2825 50.1485 64.1564 50.957L68.2381 57.0976H63.9398L60.3608 51.596H57.4721V57.0976H53.7949V39.9062H53.7978ZM61.1956 48.2552C62.9865 48.2552 64.012 47.2714 64.012 45.824V45.7734C64.012 44.1536 62.9143 43.3184 61.1234 43.3184H57.4721V48.2552H61.1956Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9628 69.9404H18.4265V73.4269H36.9628V69.9404Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4883 65.5929H38.4043V62.1064H52.2495V65.5929H47.1655V79.2978H43.4883V65.5929Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M59.1216 61.9795H62.51L69.6709 79.2957H65.829L64.3009 75.4407H57.2353L55.7072 79.2957H51.9607L59.1216 61.9795ZM60.771 66.524L58.5525 72.0999H62.9924L60.771 66.524Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3031 17.707H18.6259V34.8984H22.3031V17.707Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M68.0012 25.5439H48.7456V29.0304H68.0012V25.5439Z",
  fill: "white"
});

const SvgIncortaBlueLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 88,
  height: 97,
  viewBox: "0 0 88 97",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIncortaBlueLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/incorta-blue-logo.0d8bce14.svg";
export { ForwardRef as ReactComponent };